import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { PresetPlansService } from "@features/standby-plan/services/preset-plans.service";
import { ButtonComponent } from "@shared/components";
import { PreviewPlan } from "@shared/models";
import { MinutesToTimePipe } from "@shared/pipes";
import { GlobalService } from "@shared/services";
import { DialogModule } from "primeng/dialog";

@Component({
  selector: "app-preview-plan",
  standalone: true,
  imports: [DialogModule, ButtonComponent, MinutesToTimePipe],
  templateUrl: "./preview-plan.component.html",
  styleUrl: "./preview-plan.component.scss",
})
export class PreviewPlanComponent implements OnInit {
  globalService = inject(GlobalService);
  presetPlansService = inject(PresetPlansService);

  @Input() planType: { label: string; value: string } = { label: "", value: "" };
  @Input() defaults: { vmaxDefault: string; projDefault: string } = { vmaxDefault: "", projDefault: "" };
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  previewPlanTable: PreviewPlan[] = [];

  ngOnInit(): void {
    this.previewPlanTable = this.presetPlansService.getPreviewTable(
      this.planType.value,
      this.defaults.vmaxDefault,
      this.defaults.projDefault
    );
  }

  closeDialog(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  createPlan(): void {
    this.presetPlansService.createPlan(this.planType.value, this.defaults.vmaxDefault, this.defaults.projDefault);
    this.closeDialog();
  }
}
